import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ApplicationSecurityService {
  baseUrl: string = `${environment.API_SERVER}/api/v1`;
  constructor(private _http: HttpClient) {}

  getEventLogs(payload) {
    return this._http.get(this.baseUrl + '/event-logs/all', {
      params: payload.params,
    });
  }

  createAlert(payload) {
    return this._http.get(this.baseUrl + '/create-alert', {
      params: payload.params,
    });
  }

  getAllIpManagement(payload) {
    return this._http.get(this.baseUrl + '/ip/blacklisted', {
      params: payload.params,
    });
  }

  configureIpResponse(payload) {
    return this._http.put(
      this.baseUrl +
        `/ip/blacklist-response?responseMessAGE=${payload.responseMessage}`,
      payload.body
    );
  }
  whitelistIpAddress(payload) {
    return this._http.delete(
      this.baseUrl + `/ip/whitelist?blacklistedIpId=${payload.blacklistedIpId}`,
      payload
    );
  }
  blacklistIpAddress(payload) {
    return this._http.post(this.baseUrl + '/ip/blacklist', payload.body);
  }
  updateFileUploadMaxSize(payload) {
    return this._http.put(
      this.baseUrl + '/file-management/response-message',
      payload.body
    );
  }

  updateFileTypes(payload) {
    return this._http.put(
      this.baseUrl + '/file-management/types',
      payload.body
    );
  }

  updateFileSize(payload) {
    return this._http.put(
      this.baseUrl + '/file-management/sizing',
      payload.body
    );
  }

  updateFileConcurrentLimit(payload) {
    return this._http.put(
      this.baseUrl + '/file-management/concurrent-uploads',
      payload.body
    );
  }

  configureFileResponseMessage(payload) {
    return this._http.put(
      this.baseUrl + '/file-management/response-message',
      payload.body
    );
  }

  getAllFileManagementSettings(payload) {
    return this._http.get(this.baseUrl + '/file-management/settings', {
      params: payload.params,
    });
  }

  getAllFileUploads(payload) {
    return this._http.get(this.baseUrl + '/event-logs/by-type', {
      params: payload.params,
    });
  }

  getRequestLogs(payload) {
    return this._http.get(this.baseUrl + '/request-logs/', {
      params: payload.param,
    });
  }

  blackListIP(payload) {
    return this._http.post(this.baseUrl + '/ip/blacklist', payload.body);
  }

  whiteListIP(blacklistedIpId: any) {
    return this._http.delete(
      this.baseUrl + `/ip/whitelist?blacklistedIpId=${blacklistedIpId}`
    );
  }
}
